<template>
  <div class="select">
    <select v-model="selectedParcel" name="parcels" id="plots" class="form-control">
      <option v-for="(option, index) in filteredParcels" :value="index + 1">{{ index + 1 }} x de R$ {{ option }} </option>
    </select>
  </div>
</template>

<script>
  export default {
    name: 'parcels',

    props: {
      maxParcels: {
        default: () => {}
      }
    },

    mounted() {
      let vm = this;
      $('.card-brand-select').click(function() {
        vm.brand = $(this).val();
      });

      this.$root.$on('updateMaxParcels', (payload) => {
        this.selectedParcel = 1;
        this.parcels = payload
      });
    },

    computed: {
      filteredParcels() {
        return (this.brand != 'diners')
          ? this.parcels
          : this.parcels.slice(0, 3);
      },
    },

    data() {
      return {
        parcels: this.maxParcels,
        brand: undefined,
        selectedParcel: 1,
      }
    },

    watch: {
      selectedParcel(value) {
        this.$root.$emit('update-show-total', value);
      },
    },
  };
</script>

<style scoped>
  .select {
    max-width: 320px;
    margin: auto;
  }
</style>


// WEBPACK FOOTER //
// resources/assets/js/store/components/Parcels.vue